import { Routes } from '@angular/router';
import {VaultProfileSigninComponent} from './pages/vault-profile-signin/vault-profile-signin.component';
import {WelcomeComponent} from './pages/welcome/welcome.component';
import {VaultProfileSigninCodeComponent} from './pages/vault-profile-signin-code/vault-profile-signin-code.component';
import {IdentityVerificationComponent} from './pages/identity-verification/identity-verification.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {HealthSystemSearchComponent} from './pages/health-system-search/health-system-search.component';
import {
  HealthSystemBrandDetailsComponent
} from './pages/health-system-brand-details/health-system-brand-details.component';
import {HealthSystemConnectingComponent} from './pages/health-system-connecting/health-system-connecting.component';
import {CompleteComponent} from './pages/complete/complete.component';
import {
  FormHealthSystemRequestComponent
} from './pages/form-health-system-request/form-health-system-request.component';
import {FormSupportRequestComponent} from './pages/form-support-request/form-support-request.component';
import {IsAuthenticatedAuthGuard} from './auth-guards/is-authenticated-auth-guard';
import {
  IdentityVerificationErrorComponent
} from './pages/identity-verification-error/identity-verification-error.component';
import {IsTefcaModeAuthGuard} from "./auth-guards/is-tefca-mode-auth-guard";
import {SplashComponent} from "./pages/splash/splash.component";
import {AuthCallbackComponent} from "./pages/auth-callback/auth-callback.component";
import {
  ThirdPartyCookiesErrorComponent
} from "./pages/third-party-cookies-error/third-party-cookies-error.component";
import {hasCompletedSigninWelcomeGuard} from './auth-guards/has-completed-signin-welcome-guard';
import {ProfileComponent} from './pages/profile/profile.component';
import {
  RecordLocatorLoadingComponent
} from './pages/record-locator-loading/record-locator-loading.component';
import {
  ConfirmHealthSystemSelectionComponent
} from './pages/confirm-health-system-selection/confirm-health-system-selection.component';
import {EmbedHeaderConfig} from './models/embed-header-config';
import {
  PreventBrowserHistoryNavigationGuard
} from './auth-guards/prevent-browser-history-navigation-guard';
import {
  PreventTefcaPreDashboardHistoryNavigationGuard
} from './auth-guards/prevent-tefca-pre-dashboard-history-navigation-guard';

const headerData = (header: EmbedHeaderConfig) => ({header});
const plainHeader = headerData({});
const dashboardHeader = headerData({
  showReportIssueButton: true,
  showProfileButton: true,
  showCloseButton: true,
});
const dashboardBackHeader = headerData({
  showBackButton: true,
  backUrl: '/dashboard',
  showReportIssueButton: true,
  showCloseButton: true,
});

//TODO: SECURITY: should enable authguard everywhere where possible.
export const routes: Routes = [
  { path: 'auth/signin', component: WelcomeComponent, canActivate: [PreventTefcaPreDashboardHistoryNavigationGuard], data: plainHeader },
  { path: 'auth/signin/email', component: VaultProfileSigninComponent, canActivate: [PreventTefcaPreDashboardHistoryNavigationGuard, hasCompletedSigninWelcomeGuard], data: plainHeader },
  { path: 'auth/signin/code', component: VaultProfileSigninCodeComponent, canActivate: [PreventTefcaPreDashboardHistoryNavigationGuard], data: plainHeader },
  { path: 'auth/signin/cookies-required', component: ThirdPartyCookiesErrorComponent, canActivate: [PreventTefcaPreDashboardHistoryNavigationGuard], data: plainHeader },
  { path: 'auth/callback', component: AuthCallbackComponent, canActivate: [PreventTefcaPreDashboardHistoryNavigationGuard], data: plainHeader },
  { path: 'auth/identity/verification', component: IdentityVerificationComponent, canActivate: [PreventTefcaPreDashboardHistoryNavigationGuard], data: plainHeader, }, //canActivate: [IsAuthenticatedAuthGuard] },
  { path: 'auth/identity/verification/error', component: IdentityVerificationErrorComponent, canActivate: [PreventTefcaPreDashboardHistoryNavigationGuard], data: plainHeader}, //canActivate: [IsAuthenticatedAuthGuard] },

  { path: 'splash', component: SplashComponent, canActivate: [PreventTefcaPreDashboardHistoryNavigationGuard, IsAuthenticatedAuthGuard], data: plainHeader},
  { path: 'dashboard/loading', component: RecordLocatorLoadingComponent, canActivate: [IsAuthenticatedAuthGuard, IsTefcaModeAuthGuard], data: headerData({showCloseButton: true}) },
  { path: 'dashboard', component: DashboardComponent, canActivate: [IsAuthenticatedAuthGuard, IsTefcaModeAuthGuard], data: dashboardHeader },
  { path: 'dashboard/confirm', component: ConfirmHealthSystemSelectionComponent, canActivate: [IsAuthenticatedAuthGuard, IsTefcaModeAuthGuard], data: dashboardBackHeader },
  { path: 'profile', component: ProfileComponent, canActivate: [IsAuthenticatedAuthGuard, IsTefcaModeAuthGuard], data: headerData({showBackButton: true, backUrl: '/dashboard', showCloseButton: true}) },
  { path: 'search', component: HealthSystemSearchComponent, canActivate: [IsAuthenticatedAuthGuard], data: dashboardBackHeader },
  { path: 'brand/details', component: HealthSystemBrandDetailsComponent, canActivate: [PreventBrowserHistoryNavigationGuard, IsAuthenticatedAuthGuard], data: headerData({showBackButton: true, backUrl: '/search', backReplaceUrl: true, showReportIssueButton: true, showCloseButton: true}) },

  //cannot be authenticated, must be publically accessible for reconnecting
  {
    path: 'dashboard/connecting',
    component: HealthSystemConnectingComponent,
    canActivate: [PreventBrowserHistoryNavigationGuard],
    data: headerData({
      showBackButton: true,
      backUrl: '/dashboard',
      hideBackWhenQueryParam: 'orgConnectionId',
      showReportIssueButton: true,
      showCloseButton: true,
      reportIssueQueryParamMap: {
        brandId: 'brand_id',
        portalId: 'portal_id',
        endpointId: 'endpoint_id',
        orgConnectionId: 'org_connection_id',
        externalId: 'external_id',
        externalState: 'external_state',
      },
    }),
  },
  { path: 'dashboard/complete', component: CompleteComponent, canDeactivate: [PreventBrowserHistoryNavigationGuard], data: headerData({showReportIssueButton: true, showCloseButton: true, closeAction: 'complete-and-close'}) },

  { path: 'form/healthsystem', component: FormHealthSystemRequestComponent, data: headerData({showBackButton: true, backUrl: '/dashboard'}) },
  { path: 'form/support', component: FormSupportRequestComponent, data: headerData({showBackButton: true, backUrl: '/dashboard'}) },

  { path: '', redirectTo: '/auth/signin', pathMatch: 'full' },

  //must be at bottom of list
  { path: '**', redirectTo: 'auth/signin' },
];
